<template>
  <div id="join">
    <div class="banner">
      <div class="banner_text">
        宝枫林商城是国内首家专注于为生命科学和生物制药领域的科学家
        /制造工程师提供全方位服务的创新型企业；致力于引进、推广与普及行业领域新产品与新技术
        ，打造最全的生物试剂、耗材、仪器、技术服务一站式供应平台
      </div>
      <button class="banner_button" @click="immed()">立即入驻</button>
    </div>
    <div style="width:1200px;margin:0 auto">
      <div class="title">招商简介</div>
      <div class="english_title">In introduction</div>
      <div class="info_content">
        客户精准而广泛：生物试剂、设备、耗材产品业已覆盖全国的各大高校、研究所、生物制药研发与生产企业，并拓展至韩国、日本、南美。未来，公司将全方位整合各方面的资源，不断迭代升级宝枫林平台的终极购物体验，以科技创新的力量推动生物行业发展的升级和换代
        <div class="content_title">供应商“3免”福利</div>审批通过的前50名店铺申请入驻者可获得1年免费店铺入驻资格
        <br>产品数据库SKU50万内的免费上传
        <br>平台订单免佣金提成
        <br>
        <span class="content_title">数据库提交与资质审核方式</span>
        <br>数据库按品牌作优先匹配筛选，即同一品牌如果宝枫林平台数据库中已经有的择优数据库全者做优先录用
        <br>数据库与资质提交方式：宝枫林平台下载数据库模板导入产品后选择“在线网络提交”，或者邮件提交“okr@bioflin.com”。
        <br>
      </div>
      <div class="big_icon">
        <div class="icon">
          <img :src="serve+ '/shop_join/open.png'" alt>
        </div>
        <div class="icon">
          <img :src="serve+ '/shop_join/shop.png'" alt>
        </div>
        <div class="icon">
          <img :src="serve+ '/shop_join/buy.png'" alt>
        </div>
        <div class="icon">
          <img :src="serve+ '/shop_join/root.png'" alt>
        </div>
      </div>
      <div style="margin-top: 79px;" class="platform">
        <div class="platform_div1">
          <p>平台介绍</p>
          <p>Platform is introduced</p>
        </div>
        <div class="platform_div2">
          <div>
            <p>自主运营后台</p>
            <p>商家自建或第三方物流</p>
            <p>第三方零售平台,提供正品低价的购物选择</p>
            <p>国内商家首选的自零售平台,诚邀优质品牌入驻</p>
            <p>为您赋能多样玩法,助力玩转亿级社交渠道</p>
          </div>
          <div>
            <img :src="serve + '/shop_join/create_order.png'" alt>
          </div>
        </div>
      </div>
      <div class="platform" style="background-color: rgb(245, 245, 245);">
        <div class="platform_div1">
          <p>入驻流程</p>
          <p>Platform is introduced</p>
        </div>
        <div class="platform_div2">
          <img :src="serve + '/shop_join/six.png'" alt>
        </div>
      </div>
      <div class="platform" style="background-color: rgb(251, 251, 251);">
        <div class="platform_div1">
          <p>入驻所需资质和说明</p>
          <p>Qualification and description required for entry</p>
        </div>
        <div
          class="platform_div2"
          style="width:1200px;
                height:40px;
                background:rgba(238,238,238,1);
                line-height:40px;"
        >
          <span>所需材料</span>
          <span>详细说明</span>
        </div>
        <div
          class="platform_div2"
          style="width:1200px;
                height:40px;
                background:rgba(255,255,255,1);
                line-height:40px;"
        >
          <span>营业执照</span>
          <span>详细说明</span>
        </div>
        <div
          class="platform_div2"
          style="width:1200px;
                height:40px;
                background:rgba(238,238,238,1);
                line-height:40px;"
        >
          <span>税务登记证</span>
          <span>详细说明</span>
        </div>
        <div
          class="platform_div2"
          style="width:1200px;
                height:40px;
                background:rgba(255,255,255,1);
                line-height:40px;"
        >
          <span>组织机构代码证</span>
          <span>详细说明</span>
        </div>
        <div
          class="platform_div2"
          style="width:1200px;
                height:40px;
                background:rgba(238,238,238,1);
                line-height:40px;"
        >
          <span>一般纳税人资格证</span>
          <span>详细说明</span>
        </div>
        <div
          class="platform_div2"
          style="width:1200px;
                height:40px;
                background:rgba(255,255,255,1);
                line-height:40px;"
        >
          <span>银行开户行许可证</span>
          <span>详细说明</span>
        </div>
        <div
          class="platform_div2"
          style="width:1200px;
                height:40px;
                background:rgba(238,238,238,1);
                line-height:40px;
                text-align:left"
        >
          <span>销售授权书</span>
          <span>详细说明</span>
        </div>
      </div>
      <div class="platform1">
        <button class="banner_button1" @click="immed()">立即入驻</button>
      </div>
      <el-dialog
        style="color:rgba(102,102,102,1);"
        width="560px"
        center
        title="—————　表格提交　—————"
        :visible.sync="outerVisible"
      >
        <span>
          因平台功能还在开发中，请先提交平台需要您准备的材料，以方便后续
          快捷入驻，提交表格为Excel表格，请参考模板录入，点击下方文章下载
          模板，录入完成即可上传。
        </span>
        <div
          slot="footer"
          style="display:flex;justify-content: center;position: relative;"
          class="dialog-footer"
        >
          <div>
            <el-button @click="template1()" style="margin-left:60px" size="mini">模板下载</el-button>
          </div>
          <div>
            <el-button size="mini" style="margin-left:40px">上传表格</el-button>
          </div>
          <div style="width:80px">
            <input class="ipt" @change="getexcal($event)" type="file">
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      outerVisible: false
    };
  },
  methods: {
    getexcal(v) {
      const formData = new FormData();
      formData.append("file", v.target.files[0]);
      this.axios
        .post(this.serve + "/upload_shop_join", formData)
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "上传成功"
            });
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    immed() {
      this.outerVisible = true;
    },
    template1() {
      window.location.href = this.serve + "/download_join_model";
    }
  }
};
</script>
<style lang="scss">
#join {
  .ipt {
    position: absolute;
    top: 3px;
    left: 244px;
    opacity: 0;
  }
  .platform {
    width: 100%;
    margin: 0 auto;
    background: rgba(251, 251, 251, 1);
    .platform_div1 {
      padding-top: 30px;
      width: 300px;
      margin: 0 auto;
      text-align: center;
      :nth-child(1) {
        font-family: "MicrosoftYaHei";
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        font-size: 20px;
      }
      :nth-child(2) {
        font-size: 20px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        padding-bottom: 20px;
      }
    }
    .platform_div2 {
      display: flex;
      justify-content: space-around;
    }
  }
  .big_icon {
    margin-top: 59px;
    display: flex;
    justify-content: space-around;
    .icon {
      width: 98px;
      height: 98px;
      background: rgba(84, 152, 223, 1);
      border-radius: 50%;
      img {
        margin: 0 auto;
        // line-height: 98px;
        margin-top: 23px;
      }
    }
  }
  .banner {
    width: 100%;
    height: 400px;
    background-image: url("https://www.bioflin.com:83/shop_join/banner.png");
    color: #ffffff;
    font-size: 14px;
    position: relative;
  }
  .banner_text {
    width: 780px;
    height: 40px;
    text-align: center;
    position: absolute;
    top: 141px;
    left: 50%;
    margin-left: -390px;
  }
  .banner_button {
    padding: 0;
    width: 160px;
    height: 46px;
    font-size: 16px;
    font-family: "MicrosoftYaHei";
    font-weight: 400;
    line-height: 40px;
    background-color: #fff;
    color: rgba(246, 78, 98, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -80px;
    border: none;
    outline: none;
  }
  .banner_button:hover {
    cursor: pointer;
    color: #fff;
    background-color: #e2211c;
  }
  .platform1 {
    width: 160px;
    height: 46px;
    margin: 40px auto 0 auto;
    padding-bottom: 80px;
  }
  .banner_button1 {
    width: 160px;
    height: 46px;
    border: 1px solid rgba(246, 78, 98, 1);
    border-radius: 2px;
    outline: none;
    padding: 0;
    color:rgba(246,78,98,1);
    background:rgb(245, 245, 245);
  }
  .banner_button1:hover {
    cursor: pointer;
    color: #fff;
    background-color: #e2211c;
  }
  .title {
    margin: 60px auto 0 auto;
    width: 90px;
    height: 20px;
    font-size: 20px;
    font-family: "MicrosoftYaHei";
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .english_title {
    margin: 7px auto;
    width: 155px;
    height: 16px;
    font-size: 20px;
    font-family: "MicrosoftYaHei";
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
  .info_content {
    margin: 0 auto;
    width: 1196px;
    color: #333333;
    margin-top: 39px;
  }
  .content_title {
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
  }
}
</style>